import {
  commonGetters,
  commonActions,
  commonMutations
} from '@/store/store_utils'
import { getAxiosObject } from '@/utils/library'
import { toStateName } from '@/utils/convert_string'

const dataName = 'nxMeasurementResults'
const keys = ['measurementResultId']

const state = {
  nxMeasurementResults: [],
  updatedAt: '20101010101010'
}
keys.forEach(key => {
  state[toStateName(key)] = null
})

const getters = {
  ...commonGetters(dataName, ['getUpdatedAt'], {
    filterDel: true,
    getDataBy: keys
  }),
  getDatumByMeasurementResultId: state => measurementResultId => {
    return state.dataByMeasurementResultId?.[measurementResultId]?.[0]
  }
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter']),
  async fetchDataByMeasurementResultId({ commit }, measurementResultId) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.get('/nx-measurement-results', {
        params: { measurementResultId }
      })
      if (res.status === 200) {
        commit('updateAfter', [res.data.nxMeasurementResult])
        return 'success'
      }
    } catch {
      return 'failure'
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {
    setDataBy: keys
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
